var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-table-card",
    { staticClass: "card" },
    [
      _c(
        "form",
        {
          attrs: { novalidate: "" },
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.search.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "md-layout",
            { staticClass: "search", attrs: { "md-align": "end" } },
            [
              _c(
                "md-layout",
                {
                  staticClass: "searchContainer",
                  attrs: { "md-flex": "40", "md-align": "end" }
                },
                [
                  _c(
                    "md-layout",
                    [
                      _c(
                        "md-input-container",
                        [
                          _c("label", [_vm._v("Search")]),
                          _c("md-input", {
                            on: {
                              keypress: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search()
                              }
                            },
                            model: {
                              value: _vm.searchText,
                              callback: function($$v) {
                                _vm.searchText = $$v
                              },
                              expression: "searchText"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.searchText != ""
                    ? _c(
                        "md-layout",
                        { attrs: { "md-flex": "15" } },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "clean-search-label-btn md-icon-button btn",
                              on: { click: _vm.cleanSearchText }
                            },
                            [
                              _c("md-icon", {
                                staticClass: "icon",
                                attrs: { "md-iconset": "fa fa-trash-alt" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "10" } },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "search-btn md-icon-button btn",
                          attrs: { type: "submit", disabled: _vm.loading }
                        },
                        [
                          _c("md-icon", {
                            staticClass: "icon",
                            attrs: { "md-iconset": "fa fa-search" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.loading
        ? _c("stitch-loader", { attrs: { loading: _vm.loading, size: 45 } })
        : _vm._e(),
      _vm.hasMediaSourcesToDisplay
        ? _c(
            "div",
            [
              _c("div", { staticClass: "titleLine styleRow" }, [
                _c(
                  "p",
                  {
                    staticClass: "rowElements sortable",
                    on: {
                      click: function($event) {
                        return _vm.onSort("name")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Name " +
                        _vm._s(
                          _vm.sort.name === "name"
                            ? _vm.sort.type === "desc"
                              ? "↓"
                              : "↑"
                            : ""
                        )
                    )
                  ]
                ),
                _c(
                  "p",
                  {
                    staticClass: "rowElements sortable",
                    on: {
                      click: function($event) {
                        return _vm.onSort("status")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Status " +
                        _vm._s(
                          _vm.sort.name === "status"
                            ? _vm.sort.type === "desc"
                              ? "↓"
                              : "↑"
                            : ""
                        ) +
                        " "
                    )
                  ]
                ),
                _c(
                  "p",
                  {
                    staticClass: "rowElements sortable",
                    on: {
                      click: function($event) {
                        return _vm.onSort("lastUpdated")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Updated " +
                        _vm._s(
                          _vm.sort.name === "lastUpdated"
                            ? _vm.sort.type === "desc"
                              ? "↓"
                              : "↑"
                            : ""
                        )
                    )
                  ]
                ),
                _c("p", { staticClass: "rowElements" })
              ]),
              _vm._l(_vm.mediaSources, function(mediaSource) {
                return _c(
                  "div",
                  { key: mediaSource._id, staticClass: "styleRow colorHover" },
                  [
                    _c("div", { staticClass: "rowElements" }, [
                      _vm._v(_vm._s(mediaSource.name))
                    ]),
                    _c("div", { staticClass: "rowElements" }, [
                      _vm._v(_vm._s(mediaSource.status))
                    ]),
                    _c("div", { staticClass: "rowElements" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(mediaSource.lastUpdated, "from")
                        ) + " "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "rowElements" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-icon-button md-raised btn",
                            on: {
                              click: function($event) {
                                return _vm.editMediaSource(mediaSource._id)
                              }
                            }
                          },
                          [
                            _c("md-icon", {
                              staticClass: "icon",
                              attrs: { "md-iconset": "fa fa-pencil-alt" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _c("md-table-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.hasMediaSourcesToDisplay,
            expression: "hasMediaSourcesToDisplay"
          }
        ],
        attrs: {
          "md-size": _vm.currentPagination.size,
          "md-total": _vm.totalMediaSources,
          "md-page": _vm.currentPagination.page,
          "md-label": "Video Sources",
          "md-separator": "of",
          "md-page-options": [10, 25, 50, 100]
        },
        on: { pagination: _vm.onPageChanged }
      }),
      _vm.hasNoResults
        ? _c(
            "div",
            { attrs: { id: "no-results" } },
            [
              _c("md-icon", {
                staticClass: "md-accent",
                attrs: { "md-iconset": "fa fa-exclamation-circle" }
              }),
              _vm._v("No items to show")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed1c9fee", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed1c9fee","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaSource/MediaSourceTable.vue
// module id = 982
// module chunks = 0